module.exports = __webpack_public_path__ + "img/mq.6fc074f9.svg";